import React, { useEffect, useState } from "react";
import { MovePersonButton } from "@/components/nds/MovePerson";
import { Pencil, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { apiClient, formatApiError, useAuth } from "@/lib/auth";
import { Btn, Pill } from "./kit";
import { StaffEditDialog } from "./StaffEditDialog";
import { LoginPinButton, PinStatus, useLoginPinRefresh } from "./LoginPin";
import { PreviewAsButton } from "./PreviewAs";

export const StaffTab = ({ meta }) => {
  const { user: me } = useAuth();
  const [rows, setRows] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => apiClient.get("/console/users").then(({ data }) => setRows(data.users)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  useLoginPinRefresh(load);
  return (
    <div className="space-y-4" data-testid="console-staff-tab">
      <div className="flex justify-between items-center">
        <p className="text-sm text-white/60">{rows.length} TEA staff &amp; admin accounts</p>
        <Btn data-testid="staff-add" onClick={() => setEdit({})}><UserPlus size={12} /> Add member</Btn>
      </div>
      <div className="overflow-x-auto border border-white/10 rounded-sm">
        <table className="w-full text-sm">
          <thead><tr className="text-left border-b border-white/10 font-mono text-[10px] tracking-[0.18em] uppercase text-white/50">
            <th className="p-3">Name</th><th className="p-3">Role</th><th className="p-3">Status</th><th className="p-3">Permissions</th><th className="p-3">PIN</th><th className="p-3" />
          </tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} data-testid={`staff-row-${u.id}`} className="border-b border-white/5 hover:bg-white/[0.02] transition-colors">
                <td className="p-3"><div className="text-white">{u.name}{u.id === me?.id && <span className="ml-2 text-[10px] text-[#d4a017]">(you)</span>}</div>
                  <div className="text-[11px] text-white/50 font-mono">{u.email}{u.title ? ` · ${u.title}` : ""}</div></td>
                <td className="p-3"><Pill v={u.role} /></td>
                <td className="p-3"><Pill v={u.status} testId={`staff-status-${u.id}`} /></td>
                <td className="p-3 text-[11px] text-white/60 font-mono max-w-[220px]">{u.role === "super_admin" ? "all" : u.staff_permissions.join(", ") || "—"}</td>
                <td className="p-3"><PinStatus row={u} testId={`staff-pin-${u.id}`} /></td>
                <td className="p-3 text-right whitespace-nowrap"><LoginPinButton kind="staff" id={u.id} name={u.name} login={u.email} source="console_users_staff" className="mr-2" /><PreviewAsButton kind="staff" id={u.id} name={u.name} className="mr-2" /><MovePersonButton kind="staff" id={u.id} onDone={load} className="mr-2" /><Btn tone="muted" data-testid={`staff-edit-${u.id}`} onClick={() => setEdit(u)}><Pencil size={12} /> Edit</Btn></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && <StaffEditDialog user={edit} meta={meta} me={me} onClose={() => setEdit(null)} onSaved={load} />}
    </div>
  );
};
